import React, { useState } from 'react';
import '../css/Navbar.css'; // Apni CSS file ka path sahi check karein
import LogoImg from '../assets/logo.jpeg'; // Aapka academy logo file
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [subMenus, setSubMenus] = useState({
    about: false,
    courses: false,
    nebosh: false,
    studentPortal: false
  });

  const toggleMainMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleSubMenu = (menuKey) => {
    setSubMenus(prevState => ({
      ...prevState,
      [menuKey]: !prevState[menuKey]
    }));
  };

  return (
    <header className="gfi-navbar-container">
      
      {/* --- 1. TOP ANNOUNCEMENT BAR --- */}
      <div className="gfi-top-bar">
        <div className="gfi-announcement-container">
          <span className="gfi-badge">NEW</span>
          <div className="gfi-marquee-wrapper">
            <p className="gfi-marquee-text">
              NEBOSH IGC, IOSH, Diploma in Fire & Safety. Early Bird Discount Available! | 🏆 Award Winning Institute in Gorakhpur! | Globally Certified Programs: Comprehensive training for NEBOSH IGC, IOSH Managing Safely, and specialized University-approved Diplomas in Fire & Safety.
            </p>
          </div>
        </div>
        <div className="gfi-top-actions">
          <a href="#student-ims" className="gfi-top-link">Student IMS</a>
          <a href="#e-learning" className="gfi-top-link">E-Learning</a>
        </div>
      </div>

      {/* --- 2. MAIN BRANDING HEADER BAR --- */}
      <div className="gfi-main-bar">
        <div className="gfi-brand-block">
          <div className="gfi-logo-area">
            <img src={LogoImg} alt="Greenfield Academy Logo" />
          </div>
          <div className="gfi-company-info">
            <h1 className="gfi-company-name">Greenfield Industrial Fire and Safety Academy</h1>
            <div className="gfi-company-creds">
              <span className="gfi-cred-badge">ISO 9001:2015</span>
              <span className="gfi-cred-reg">Reg No: GFI-2026/A921</span>
            </div>
          </div>
        </div>

        {/* Desktop Contacts (Mobile par automatically hide ho jayenge) */}
        <div className="gfi-info-wrapper">
          <div className="gfi-info-desk">
            <div className="gfi-icon-box">📞</div>
            <div className="gfi-desk-text">
              <p className="gfi-desk-label">Admissions Desk</p>
              <p className="gfi-desk-number"> 9136218362, 9136216362</p>
            </div>
          </div>
          <div className="gfi-info-desk">
            <div className="gfi-icon-box gray">🌐</div>
            <div className="gfi-desk-text">
              <p className="gfi-desk-label">NEBOSH / International</p>
              <p className="gfi-desk-number"> 9136216362</p>
            </div>
          </div>
          <a href="#apply" className="gfi-apply-btn">APPLY NOW</a>
        </div>

        {/* Hamburger Lines (Mobile par Hamburger banega aur cross button 'X' me transform hoga) */}
        <button 
          className={`gfi-hamburger ${isMenuOpen ? 'is-active' : ''}`} 
          onClick={toggleMainMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {/* --- 3. DESKTOP CORE NAVIGATION (Image 2 Match) --- */}
      <nav className="gfi-nav-menu-bar">
        <ul className="gfi-menu-links">
         <li className="gfi-menu-item active">
  <Link to="/">Home</Link>
</li>
          <li className="gfi-menu-item">
            <a href="#about">About ▾</a>
            <ul className="gfi-submenu">
             <li><Link to="/about">Our Profile</Link></li>
              <li><Link to="/mission-vision">Objective and Mission</Link></li>
              <li><a href="#profile">Award</a></li>
              <li><Link to="/founder-message">Director Message</Link></li>
              <li><Link to="/company-registration">Company Certificate</Link></li>
               <li><Link to="/iso-certificationPage">ISO Certificate</Link></li>
              <li><a href="#director">EMS Certificate</a></li>
              <li><a href="#approvals">OHSAS Certifiacte</a></li>
            </ul>
          </li>
          <li className="gfi-menu-item">
            <a href="#courses">Courses ▾</a>
            <ul className="gfi-submenu">
              <li><a href="#fire-safety">Diploma in Fire & Safety</a></li>
              <li><a href="#industrial-safety">Diploma in Industrial Safety Management</a></li>
              <li><a href="#Post-Diploma">Post Diploma in Industrial Safety</a></li>
              <li><a href="#adis">ADIS</a></li>
              <li><a href="#firstaid">FirstAid</a></li>
            </ul>
          </li>
          <li className="gfi-menu-item">
            <a href="#nebosh">Nebosh/Iosh ▾</a>
            <ul className="gfi-submenu">
              <li><a href="#nebosh-igc">NEBOSH IGC Course</a></li>
              <li><a href="#iosh">IOSH Managing Safely</a></li>
                 <li><a href="#nebosh-hsa">NEBOSH HSA(HSW)</a></li>
              <li><a href="#cpd">CPD</a></li>
            </ul>
          </li>
          <li className="gfi-menu-item">
             <ul className="gfi-submenu">
              <li><a href="#job-Opprot">Job Opportunity</a></li>
              <li><a href="#placement">Placement Partners</a></li>
                 <li><a href="#placment-record">Placement Records</a></li>

            </ul>
            </li>
          <li className="gfi-menu-item">
            <a href="#student-portal">Student Portal ▾</a>
            <ul className="gfi-submenu">
                <li><a href="#admission">Admission Verification</a></li>
              <li><a href="#results">Examination Results</a></li>
              <li><a href="#verification">Certificate Verification</a></li>
            </ul>
          </li>
           <li className="gfi-menu-item"><a href="#placement">Placement</a></li>
          <li className="gfi-menu-item"><Link to="/franchise-page">Franchise</Link></li>
          <li className="gfi-menu-item"><a href="#blog">Blog</a></li>
          <li className="gfi-menu-item"><Link to="/contact">Contact</Link></li>
        </ul>
      </nav>

      {/* --- 4. STREAMLINED MOBILE DRAWER PANEL (Screenshot 4 Match) --- */}
      <div className={`gfi-mobile-drawer ${isMenuOpen ? 'is-open' : ''}`}>
        
        {/* Portals Section */}
        <p className="gfi-mob-section-title">Portals</p>
        <div className="gfi-mobile-quick-links">
          <a href="#student-ims" className="gfi-mob-portal-card" onClick={() => setIsMenuOpen(false)}>Student IMS</a>
          <a href="#e-learning" className="gfi-mob-portal-card" onClick={() => setIsMenuOpen(false)}>E-Learning</a>
        </div>

        {/* Contact Desks Section */}
        <p className="gfi-mob-section-title">Contact Desks</p>
        <div className="gfi-mobile-desks">
          <div className="gfi-mob-desk-card">
            <p className="gfi-mob-desk-label">ADMISSIONS DESK</p>
            <p className="gfi-mob-desk-val">8448445028 / 8102955178</p>
          </div>
          <div className="gfi-mob-desk-card">
            <p className="gfi-mob-desk-label">NEBOSH / INTERNATIONAL</p>
            <p className="gfi-mob-desk-val">7970997369</p>
          </div>
        </div>

        {/* Navigation Menu Accordion Links */}
        <p className="gfi-mob-section-title">Navigation Menu</p>
        <ul className="gfi-mobile-nav-list">
          <li><a href="#home" onClick={() => setIsMenuOpen(false)}>Home</a></li>
          
          {/* About Accordion */}
          <li>
            <div className="gfi-mob-menu-row" onClick={() => toggleSubMenu('about')}>
              <span>About</span>
              <span className={`gfi-arrow ${subMenus.about ? 'open' : ''}`}>▲</span>
            </div>
            <ul className={`gfi-mobile-submenu ${subMenus.about ? 'show' : ''}`}>
              <li><a href="#profile" onClick={() => setIsMenuOpen(false)}>Our Profile</a></li>
              <li><a href="#director" onClick={() => setIsMenuOpen(false)}>Director Message</a></li>
              <li><a href="#approvals" onClick={() => setIsMenuOpen(false)}>Accreditations & Approvals</a></li>
            </ul>
          </li>

          {/* Courses Accordion */}
          <li>
            <div className="gfi-mob-menu-row" onClick={() => toggleSubMenu('courses')}>
              <span>Courses</span>
              <span className={`gfi-arrow ${subMenus.courses ? 'open' : ''}`}>▲</span>
            </div>
            <ul className={`gfi-mobile-submenu ${subMenus.courses ? 'show' : ''}`}>
              <li><a href="#fire-safety" onClick={() => setIsMenuOpen(false)}>Diploma in Fire & Safety</a></li>
              <li><a href="#industrial-safety" onClick={() => setIsMenuOpen(false)}>Industrial Safety Management</a></li>
              <li><a href="#hse" onClick={() => setIsMenuOpen(false)}>Health & Environment (HSE)</a></li>
            </ul>
          </li>

          {/* Nebosh Accordion */}
          <li>
            <div className="gfi-mob-menu-row" onClick={() => toggleSubMenu('nebosh')}>
              <span>Nebosh/Iosh</span>
              <span className={`gfi-arrow ${subMenus.nebosh ? 'open' : ''}`}>▲</span>
            </div>
            <ul className={`gfi-mobile-submenu ${subMenus.nebosh ? 'show' : ''}`}>
              <li><a href="#nebosh-igc" onClick={() => setIsMenuOpen(false)}>NEBOSH IGC Course</a></li>
              <li><a href="#iosh" onClick={() => setIsMenuOpen(false)}>IOSH Managing Safely</a></li>
            </ul>
          </li>

          <li><a href="#placement" onClick={() => setIsMenuOpen(false)}>Placement</a></li>
          
          {/* Student Portal Accordion */}
          <li>
            <div className="gfi-mob-menu-row" onClick={() => toggleSubMenu('studentPortal')}>
              <span>Student Portal</span>
              <span className={`gfi-arrow ${subMenus.studentPortal ? 'open' : ''}`}>▲</span>
            </div>
            <ul className={`gfi-mobile-submenu ${subMenus.studentPortal ? 'show' : ''}`}>
              <li><a href="#results" onClick={() => setIsMenuOpen(false)}>Examination Results</a></li>
              <li><a href="#verification" onClick={() => setIsMenuOpen(false)}>Certificate Verification</a></li>
            </ul>
          </li>

          <li><a href="#franchise" onClick={() => setIsMenuOpen(false)}>Franchise</a></li>
          <li><a href="#blog" onClick={() => setIsMenuOpen(false)}>Blog</a></li>
          <li><a href="#contact" onClick={() => setIsMenuOpen(false)}>Contact</a></li>
        </ul>

        <a href="#apply" className="gfi-mob-apply-btn" onClick={() => setIsMenuOpen(false)}>APPLY NOW</a>
      </div>

    </header>
  );
};

export default Navbar;